import React, {useContext} from 'react';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import classes from './Toolbar.module.css';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';
import CartButton from '../../CartButton/CartButton';
import AuthContext from '../../../store/auth-context';
import ThemeContext from '../../../store/theme-context';



const Toolbar = (props) => {

    const authCtx = useContext(AuthContext);

    const themeCtx = useContext(ThemeContext);
    

    return (
    <header className={classes.Toolbar}>
        <div className={classes.Logo}>
            Colorfy
        </div>
        <DrawerToggle clicked={props.sideDrawerToggle} />
        <nav className={classes.DesktopOnly}>
            {authCtx.isLoggedIn && <CartButton />}
            <NavigationItems isAuth={props.authentication} />
            <IconButton sx={{ ml: 1, color: themeCtx.theme.palette.background.default }} onClick={themeCtx.toggleMode} >
                {themeCtx.theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </nav>
    </header>
    )
};

export default Toolbar;